module.exports = __webpack_public_path__ + "static/media/subscription-section-4.1e4ff048.png";